import { Card, CardContent, Grid, IconButton, Typography } from '@material-ui/core'
import { GetApp, Redo, Undo, ZoomIn, ZoomOut } from '@material-ui/icons'
import { useEffect, useState } from 'react'
import { download } from '../download'
import { HtmlDoc } from '../html'
import { AutoCodeRenderer } from './auto-code'
import { DemographicsRenderer } from './demographics'
import { documentApi2 } from './document-api'
import { AutoCode, DocumentRef, SuperChart } from './document-types'
import { Pdf } from './pdf'
import { SuperChartContentV2 } from './superchart/superchart'
import { NativePdf } from './native-pdf'
import { PdfJs } from './pdf-js'


type DocumentRendererProps = {
  ref: DocumentRef
  content?: string
  superChart?: SuperChart
  pdf?: any
}

const viewer = new URLSearchParams(window.location.search).get('viewer') || 'js'

export function DocumentRenderer({ ref, content, superChart, pdf }: DocumentRendererProps) {
  const [zoom, setZoom] = useState(0.95)

  ref = documentApi2.data((s) => s.ref) || ref
  pdf = documentApi2.data((s) => s.pdf) || pdf
  content = documentApi2.data((s) => s.content) || content
  superChart = documentApi2.data((s) => s.superChart) || superChart

  const demographics = documentApi2.data((s) => s.demographics)
  const html = documentApi2.data((s) => s.html)
  const autoCode: AutoCode = documentApi2.data((s) => s.autoCode)

  console.log("auto code "+ autoCode + "  demographic " + demographics)
  const onZoomIn = () => {
    setZoom(zoom * 1.1)
  }
  const onZoomOut = () => {
    setZoom(zoom * 0.9)
  }

  const [rotation, setRotation] = useState(0)

  const onRotateRight = () => {
    setRotation(rotation + 90)
  }
  const onRotateLeft = () => {
    setRotation(rotation - 90)
  }
  const onDownload = () => {
    ref && download(pdf || content, ref.key)
  }

  useEffect(() => {
    setRotation(0)
  }, [pdf, content])

  return (
    <Grid
      container
      style={{ width: '100%', height: '83vh' }}
      justify="center"
      alignItems="center"
      id="document-renderer"
    >
      {' '}
      {demographics ? (
        <DemographicsRenderer {...demographics} />
      ) : (autoCode?.cptProcedures || autoCode?.diagnoses) ? (
        <AutoCodeRenderer {...autoCode} />
      ) : superChart ? (
        <SuperChartContentV2 superChart={superChart} />
      ) : pdf ? (
        viewer === 'native' ? (
          <NativePdf content={pdf} />
        ) : viewer === 'js' ? (
          <PdfJs content={pdf} />
        ) : (
          <>
            <div style={{ position: 'absolute', zIndex: 1500, top: 70, right: 4 }}>
              <Grid container direction="column" spacing={0}>
                <Grid item>
                  <IconButton onClick={onZoomIn}>
                    <ZoomIn />
                  </IconButton>
                </Grid>
                <Grid item>
                  <IconButton onClick={onZoomOut}>
                    <ZoomOut />
                  </IconButton>
                </Grid>
                {pdf && (
                  <Grid item>
                    <IconButton onClick={onRotateLeft}>
                      <Undo />
                    </IconButton>
                  </Grid>
                )}
                {pdf && (
                  <Grid item>
                    <IconButton onClick={onRotateRight}>
                      <Redo />
                    </IconButton>
                  </Grid>
                )}
                {(pdf || content) && (
                  <Grid item>
                    <IconButton onClick={onDownload}>
                      <GetApp />
                    </IconButton>
                  </Grid>
                )}
              </Grid>
            </div>
            <Pdf content={pdf} zoom={zoom} rotation={rotation} />
          </>
        )
      ) : html ? (
        <Grid item style={{ paddingTop: 12 }}>
          <HtmlDoc html={html} />
        </Grid>
      ) : content ? (
        <Grid item style={{ paddingTop: 12 }}>
          <Card>
            <CardContent>
              <div
                style={{
                  padding: '12px',
                  width: '58vw',
                  height: '76vh',
                  overflowY: 'auto',
                }}
              >
                {(content || '').split('    ').map((value, key) => (
                  <p key={key}>
                    <Typography style={{ whiteSpace: 'pre-line' }} component={'span'} color="textSecondary">
                      {value}
                    </Typography>
                  </p>
                ))}
              </div>
            </CardContent>
          </Card>
        </Grid>
      ) : (
        <Grid item>{!content || !content?.length ? 'No Document Selected' : 'Loading...'}</Grid>
      )}
    </Grid>
  )
}
